import { createContext, useContext } from 'react';
import type { useCurrentUser, useCurrentUserNotifications } from '../hooks/auth';

export type SessionContextType = Partial<ReturnType<typeof useCurrentUser>> & {
  sessionExists?: boolean;
  setSessionExists: () => void; // No longer takes a boolean parameter
  notifications?: ReturnType<typeof useCurrentUserNotifications>;
  logout?: () => void;
};

export const SessionContext = createContext<SessionContextType>({
  sessionExists: false,
  setSessionExists: () => {},
  logout: async () => {},
});

export const useSessionContext = () => {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error('useSessionContext must be used within a Session provider');
  }
  return context;
};
